import { Injectable } from '@angular/core';
import { HttpService } from '@sdbn/appclient';
import { StationSelectionIdentity } from '../model/StationSelectionIdentity';
import { Observable } from 'rxjs';
import { StationGroup } from '../model/StationGroup';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class StationSelectionService {

  constructor(private http: HttpService) { }

  getStationStructureDefinition(entity: StationSelectionIdentity): Observable<StationGroup[]> {
    return this.http.postWithContext<StationGroup[]>(`${environment.stationSelectionEndpoint}/structure`, entity);
  }
}
